import styled, { css } from 'styled-components';

import { CommonTheme } from 'app/shared/theme';
import {
  withCursorCSS,
  WithCursorProps,
} from 'app/shared/components/styleUtils/withCursorCSS';
import {
  withDimensionsCSS,
  WithDimensionsProps,
} from 'app/shared/components/styleUtils/withDimensionsCSS';
import {
  withDisplayCSS,
  WithDisplayProps,
} from 'app/shared/components/styleUtils/withDisplayCSS';
import {
  withFontCSS,
  WithFontProps,
} from 'app/shared/components/styleUtils/withFontCSS';
import {
  withSpacingCSS,
  WithSpacingProps,
} from 'app/shared/components/styleUtils/withSpacingCSS';

export interface TypographyProps
  extends React.ComponentPropsWithoutRef<'p'>,
    WithSpacingProps,
    WithFontProps,
    WithDisplayProps,
    WithCursorProps,
    WithDimensionsProps {
  color?: string;
}

interface TypographyCSSProps extends TypographyProps {
  theme: CommonTheme;
}

export const Typography = styled.p<TypographyCSSProps>`
  ${({ theme, color, display = 'inline-block' }: TypographyCSSProps) => css`
    color: ${color ? color : theme.colors.primary.black.base};
    ${withDisplayCSS({ display })};
    margin: 0;
    padding: 0;
  `}

  ${withSpacingCSS};
  ${withFontCSS};
  ${withDimensionsCSS};
  ${withCursorCSS};
`;
